import { Component, OnInit, inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { AppMainComponent } from 'src/modules/app-template/components/app-main/app-main.component';
import { Config } from 'src/modules/app-template/models/config.model';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { FeatureModuleService } from 'src/modules/sm-base/services/feature-module.service';
import { SmBaseRoutingModule2 } from 'src/modules/sm-base/sm-base-routing2.module';
import { SmBaseModule } from 'src/modules/sm-base/sm-base.module';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'root-component',
    templateUrl: './root.component.html',
    styleUrls: ['./root.component.css']
})
export class RootComponent implements OnInit {
    app = inject(MainAppService);
    featureModuleService = inject(FeatureModuleService);
    router = inject(Router);

    async ngOnInit(): Promise<void> {
        let modules = this.featureModuleService.getModules();

        if (Utils.isNoe(modules)) {
            throw new Error("In der Konfigurationsdatei wurden keine Module registriert. Ohne Module ist das Portal nicht funktionsfähig");
        }

        for (let module of modules) {
            module.registerSidebar(this.app.menuModel);
        }

        if (this.app.mainConfig.useAdminUsers) {
            this.app.toolbarButtons = [...this.app.toolbarButtons,
                {
                    id: "admin",
                    label: "Administration",
                    routerLink: ["/base2", "admin"],
                    icon: "fas fa-cog",
                    visible: false
                }
            ];
        }

        this.app.menuModel = Utils.arraySortBy(this.app.menuModel, item => item.sort);
        for (let tab of this.app.menuModel) {
            tab.menuItems = Utils.arraySortBy(tab.menuItems, item => item.sort);
        }

        let childRoutes = modules.map(module => module.getMainRoute());
        childRoutes.push({
            path: "",
            redirectTo: Utils.stringDef(Config.get().mainRoute, childRoutes[0].path),
            pathMatch: "full"
        });
        childRoutes.push(this.featureModuleService.createModuleRoute("base2", () => SmBaseRoutingModule2));

        let routes: Routes = [
            {
                path: 'base',
                loadChildren: () => SmBaseModule
            },
            {
                path: '',
                component: AppMainComponent,
                children: childRoutes
            }
        ];

        this.router.resetConfig(routes);

        this.app.auth.onUserChanged.subscribe(async () => {
            await this.updateVisibility();
        });
        await this.updateVisibility();
    }

    private async updateVisibility(): Promise<void> {
        for (let module of this.featureModuleService.getModules()) {
            await module.updateSidebarVisibility(this.app.menuModel);
        }
        this.app.updateMenuVisibility();
        let b = this.app.toolbarButtons.find(tb => tb.id == "admin");
        if (b != null) {
            b.visible = this.app.isAdmin();
        }
    }
}
